import { AppConstants } from '@nibras/core';

export const DAILY_DATE_FORMATS = {
  parse: {
    dateInput: AppConstants.DATE_FORMAT.toUpperCase()
  },
  display: {
    dateInput: AppConstants.DATE_FORMAT.toUpperCase(),
    monthYearLabel: AppConstants.DATE_MONTH_YEAR_LABEL.toUpperCase(),
    dateA11yLabel: AppConstants.DATE_A11Y_LABEL.toUpperCase(),
    monthYearA11yLabel: AppConstants.DATE_MONTH_YEAR_A11Y_LABEL.toUpperCase()
  }
} as const;

export const MONTH_DATE_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY'
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
} as const;
